/**
 * AppCard Component
 * 
 * Class component for Chrome 68 compatibility
 */

import React, { Component } from 'react';

class AppCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageError: false,
            imageLoading: !!(props.app && props.app.icon_url)
        };
        this.handleImageError = this.handleImageError.bind(this);
        this.handleImageLoad = this.handleImageLoad.bind(this);
        this.handleVendorClick = this.handleVendorClick.bind(this);
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
    }
    
    handleImageError() {
        this.setState({ imageError: true });
    }

    handleImageLoad() {
        this.setState({ imageLoading: false });
    }
    
    handleVendorClick(event) {
        event.preventDefault();
        if (this.props.onVendorClick && this.props.app.vendor) {
            this.props.onVendorClick(this.props.app.vendor);
        }
    }
    
    handleCategoryClick(event) {
        event.preventDefault();
        if (this.props.onCategoryClick && this.props.app.category) {
            this.props.onCategoryClick(this.props.app.category);
        }
    }
    
    formatSize(sizeMb) {
        if (!sizeMb || sizeMb === 0) return '';
        if (sizeMb < 1) {
            return Math.round(sizeMb * 1024) + ' KB';
        }
        return sizeMb.toFixed(1) + ' MB';
    }
    
    formatRating(rating) {
        if (!rating || rating === 0) return '';
        var stars = '';
        var fullStars = Math.floor(rating);
        for (var i = 0; i < fullStars; i++) {
            stars += '★';
        }
        if (rating % 1 >= 0.5) {
            stars += '☆';
        }
        return stars + ' ' + rating.toFixed(1);
    }
    
    getSourceLabel(source) {
        switch (source) {
            case 'fdroid': return 'F-Droid';
            case 'uptodown': return 'Uptodown';
            case 'apkmirror': return 'APKMirror';
            case 'apkpure': return 'APKPure';
            case 'projectberry': return 'ProjectBerry';
            default: return source;
        }
    }
    
    getSourceClass(source) {
        switch (source) {
            case 'fdroid': return 'fdroid';
            case 'uptodown': return 'uptodown';
            case 'apkmirror': return 'apkmirror';
            case 'apkpure': return 'apkpure';
            case 'projectberry': return 'projectberry';
            default: return '';
        }
    }
    
    formatDate(dateStr) {
        if (!dateStr) return '';
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var date = new Date(dateStr);
        if (isNaN(date.getTime())) return '';
        var day = date.getDate();
        var month = months[date.getMonth()];
        var year = date.getFullYear();
        return day + ' ' + month + ', ' + year;
    }

    formatCount(count) {
        if (!count || count < 0) count = 0;
        if (count > 1000) return '1k+';
        if (count >= 1000) return '1k';
        return String(count);
    }

    
    render() {
        var app = this.props.app;
        var self = this;
        
        // Icon element - prefer remote icon if available, fall back to placeholder
        var iconElement;
        if (app.icon_url && !this.state.imageError) {
            // Show wrapper so we can overlay a spinner
            iconElement = React.createElement('div', { className: 'bb-app-icon-wrapper' },
                React.createElement('img', {
                    className: 'bb-app-icon',
                    src: app.icon_url,
                    alt: app.app_name || 'app icon',
                    onError: this.handleImageError,
                    onLoad: this.handleImageLoad
                }),
                this.state.imageLoading ? React.createElement('div', { className: 'bb-icon-spinner' }) : null
            );
        } else {
            var initial = app.app_name ? app.app_name.charAt(0).toUpperCase() : '?';
            iconElement = React.createElement('div', {
                className: 'bb-app-icon-placeholder'
            }, initial);
        }
        
        // Meta info
        var metaItems = [];
        if (app.version) {
            metaItems.push(
                React.createElement('span', { key: 'version', className: 'bb-app-version' },
                    'v' + app.version
                )
            );
        }
        if (app.file_size_mb) {
            metaItems.push(
                React.createElement('span', { key: 'size', className: 'bb-app-size' },
                    this.formatSize(app.file_size_mb)
                )
            );
        }
        
        // Download link - prefer direct APK link
        var downloadLink = app.direct_apk_link || app.download_link;
        var downloadText = 'Download';
        
        // Vote data
        var voteData = this.props.voteData || null;
        var upCount = voteData ? voteData.upvotes : (app.upvotes || 0);
        var downCount = voteData ? voteData.downvotes : (app.downvotes || 0);
        var userVoteType = (this.props.voteLookup && this.props.voteLookup[app.package_name]) || '';
        var alreadyUpvoted = userVoteType === 'up';
        var alreadyDownvoted = userVoteType === 'down';
        var alreadyVoted = !!userVoteType;

        var commentState = this.props.commentState || {};
        var baseCommentCount = (typeof this.props.commentCount === 'number') ? this.props.commentCount : 0;
        var commentTotal = (commentState.total || commentState.total === 0) ? commentState.total : baseCommentCount;
        var commentBadge = commentTotal > 20 ? '20+' : (commentTotal > 0 ? String(commentTotal) : '');
        var showCommentsButton = commentTotal > 0;
        var commentLoading = !!commentState.loading;

        // If counts haven't arrived yet but we know user's vote, reflect it so buttons show a number
        if (alreadyUpvoted && upCount === 0) upCount = 1;
        if (alreadyDownvoted && downCount === 0) downCount = 1;

        // Grey-out rule: if downvotes outweigh upvotes, render desaturated; the hide-at-20 rule is handled in AppGrid
        var netDown = downCount - upCount;
        var cardMuted = netDown >= 1;

        // Show source rating if present (no community badge)
        if (app.rating) {
            metaItems.push(
                React.createElement('span', { key: 'rating', className: 'bb-app-rating' },
                    this.formatRating(app.rating)
                )
            );
        }
        
        // Source badge element with proper label
        var sourceBadge = app.source ? React.createElement('span', {
            className: 'bb-app-source ' + this.getSourceClass(app.source)
        }, this.getSourceLabel(app.source)) : null;
        
        // Clickable vendor/author
        var vendorElement = app.vendor ? React.createElement('a', {
            href: '#',
            className: 'bb-app-vendor bb-app-vendor-link',
            onClick: this.handleVendorClick,
            title: 'Filter by author: ' + app.vendor
        }, app.vendor) : null;
        
        // Clickable category
        var categoryElement = app.category ? React.createElement('a', {
            href: '#',
            className: 'bb-app-category bb-app-category-link',
            onClick: this.handleCategoryClick,
            title: 'Filter by ' + app.category
        }, app.category) : null;
        
        var cardClass = 'bb-app-card' + (cardMuted ? ' bb-app-card-muted' : '');
        var cardStyle = cardMuted ? { opacity: 0.6, filter: 'grayscale(60%)' } : null;

        return React.createElement('div', { className: cardClass, style: cardStyle },
            // Header section: icon + title/author (horizontal on xs screens)
            React.createElement('div', { className: 'bb-app-card-header' },
                iconElement,
                React.createElement('div', { className: 'bb-app-card-header-info' },
                    React.createElement('h3', { className: 'bb-app-name' },
                        React.createElement('a', {
                            href: app.download_link || '#',
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            className: 'bb-app-name-link',
                            title: app.app_name
                        }, app.app_name)
                    ),
                    vendorElement
                )
            ),
            metaItems.length > 0 && React.createElement('div', { className: 'bb-app-meta' },
                metaItems
            ),
            app.last_updated && React.createElement('div', { className: 'bb-app-updated' },
                'Updated: ' + this.formatDate(app.last_updated)
            ),
            // Combined category row with source badge
            React.createElement('div', { className: 'bb-app-category-row' },
                categoryElement,
                sourceBadge
            ),
            app.description && React.createElement('p', { className: 'bb-app-description' },
                app.description
            ),
                React.createElement('div', { className: 'bb-app-actions' },
                    downloadLink && React.createElement('a', {
                        href: downloadLink + '#detail-download-button',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        className: 'bb-btn bb-btn-primary bb-btn-sm'
                    }, downloadText),
                    React.createElement('div', { className: 'bb-vote-actions' },
                        showCommentsButton ? React.createElement('button', {
                            className: 'bb-btn bb-btn-secondary bb-btn-sm bb-comment-btn' + (commentLoading ? ' disabled' : ''),
                            onClick: function() {
                                if (commentLoading) return;
                                if (self.props.onOpenComments) self.props.onOpenComments(app);
                            }
                        }, commentLoading ? '💬…' : (commentBadge ? ('💬 ' + commentBadge) : '💬')) : null,
                        React.createElement('button', {
                            className: 'bb-btn bb-btn-secondary bb-btn-sm' + (alreadyUpvoted ? ' active' : '') + (alreadyVoted ? ' disabled' : ''),
                            onClick: function() {
                                if (self.props.onVote) self.props.onVote(app, 'up');
                            }
                        }, upCount > 0 ? ('👍 ' + this.formatCount(upCount)) : '👍'),
                        React.createElement('button', {
                            className: 'bb-btn bb-btn-secondary bb-btn-sm' + (alreadyDownvoted ? ' active' : '') + (alreadyVoted ? ' disabled' : ''),
                            onClick: function() {
                                if (self.props.onVote) self.props.onVote(app, 'down');
                            }
                        }, downCount > 0 ? ('👎 ' + this.formatCount(downCount)) : '👎')
                    )
                )
        );
    }
}

export default AppCard;
